/**
 * Regex to find route parameters.
 * @type {RegExp}
 */
export const ROUTE_PARAM_REGEX = /\(?([^(]?):(\w+)\)?/g;

/**
 * Pathfinder errors prefix.
 * @type {String}
 */
export const PATHFINDER_ERROR = '[pathfinder]:';

/**
 * Fiverr's base FQDN.
 * @type {URL}
 */
export const FIVERR_FQDN = 'https://www.fiverr.com';

/**
 * The root route.
 * @type {String}
 */
export const ROOT = '/';

/**
 * Prefix to identify dev-only routes.
 * @type {String}
 */
export const DEV_PREFIX = '__dev__';
